import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { sanityFetch } from '../../lib/sanity';
import { guideQueries } from '../../lib/sanityQueries';
import HubPageLayout from './HubPageLayout';
import SpokePageLayout from './SpokePageLayout';

const GuidePage = () => {
  const { slug } = useParams();
  const [guide, setGuide] = useState(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const fetchGuide = async () => {
      setStatus('loading');
      try {
        const data = await sanityFetch(guideQueries.getGuideBySlug, { slug });
        if (!data) {
          setStatus('not_found');
          return;
        }
        setGuide(data);
        setStatus('ready');
      } catch (err) {
        console.error('Error loading guide page', err);
        setStatus('error');
      }
    };

    if (slug) fetchGuide();
  }, [slug]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin" />
          <p className="text-white/70">Loading guide...</p>
        </div>
      </div>
    );
  }

  if (status === 'not_found') {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-3">Guide not found</h1>
          <p className="text-white/60 mb-6">We couldn&apos;t find a guide for &ldquo;{slug}&rdquo;.</p>
          <Link to="/" className="inline-flex items-center text-emerald-400 hover:text-emerald-300">
            <svg className="w-4 h-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to home
          </Link>
        </div>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-3">Error loading guide</h1>
          <p className="text-white/60">Please refresh or try again later.</p>
        </div>
      </div>
    );
  }

  // Conditional rendering based on hubSpoke type
  if (guide.hubSpoke === 'hub') {
    return <HubPageLayout guide={guide} />;
  }

  return <SpokePageLayout guide={guide} />;
};

export default GuidePage;
